import { isEqual } from "lodash";

import { astToString } from "./ast-to-string";
import { evaluateAst } from "./evaluate-formula";
import { generateQuery } from "./generate-query";
import { parseToAst } from "./parse-to-ast";
import { type AstNode } from "./types";

export class FormulaEvaluator {
  formula: string;

  constructor(formula: string | AstNode) {
    this.formula = this.setFormula(formula);
  }

  isValid() {
    try {
      this.toAst();
      return true;
    } catch (e) {
      return false;
    }
  }

  setFormula(formula: string | AstNode) {
    if (typeof formula === "object") {
      this.formula = astToString(formula);
    } else {
      this.formula = formula;
    }
    return this.formula;
  }

  toAst() {
    return parseToAst(this.formula);
  }

  compareAst(astToCompare: AstNode) {
    try {
      return isEqual(this.toAst(), astToCompare);
    } catch (error) {
      return false;
    }
  }

  getFormulaVariables() {
    if (this.isValid()) {
      const ast = this.toAst();
      const variables: string[] = [];
      const getVariables = (node: AstNode) => {
        if (node.type === "variable") {
          variables.push(node.value);
        } else if (node.type === "operator") {
          getVariables(node.left);
          getVariables(node.right);
        }
      };
      getVariables(ast);
      return variables;
    }
    return [];
  }

  getQuery(data: Record<string, string>) {
    return generateQuery(this.toAst(), data);
  }

  evaluate(data?: Record<string, number>): number {
    const ast = this.toAst();
    return evaluateAst(ast, data);
  }
}
